import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import AssetFileUploader from './AssetFileUploader';
import { Divider, Grid } from '@material-ui/core';
import AssetsHeaderWithCount from '../AssetsLabelCount';
import BackNextButtonContainer from '../BackNextButtonContainer';
import AssetManualEntry from './AssetManualEntry';
import AssetCSVUpload from './AssetCSVUpload';
import MissingProductsDialog from './MissingProductsDialog';
import RemoveCircleIcon from '@material-ui/icons/RemoveCircle';
import { Button, Tooltip } from '@material-ui/core';
import { removeInvalidAssets } from '../../../redux/actions/assetsAction';

const RenderCSVUploadOrManualEntryView = () => {
	const isCSVUploadViewLoaded = useSelector((state) => state.isCSVUploadViewLoaded);
	if (isCSVUploadViewLoaded) {
		return <AssetCSVUpload />;
	} else {
		return <AssetManualEntry />;
	}
};

const RemoveInvalidAssetsBtn = () => {
	const dispatch = useDispatch();
	const removeAllInvalidAssets = () => {
		dispatch(removeInvalidAssets());
	};
	return (
		<Tooltip title="Remove Invalid Assets" placement="top" arrow={true}>
			<span>
				<Button startIcon={<RemoveCircleIcon />} color="primary" onClick={removeAllInvalidAssets}>
					Remove
				</Button>
			</span>
		</Tooltip>
	);
};

const UpLoadFiles = () => {
	return (
		<Grid container direction="column" spacing={3}>
			<Grid item>
				<RenderCSVUploadOrManualEntryView />
			</Grid>
			<Grid item>
				<Grid container>
					<Grid item xs={2}>
						<BackNextButtonContainer />
					</Grid>
					<Grid item>
						<MissingProductsDialog />
					</Grid>
				</Grid>
			</Grid>
			<Grid item>
				<Grid container>
					<Grid item xs={11}>
						<AssetsHeaderWithCount />
					</Grid>
					<Grid item xs={1}>
						<RemoveInvalidAssetsBtn />
					</Grid>
				</Grid>
			</Grid>
			<Grid item>
				<Divider />
			</Grid>
			<AssetFileUploader />
		</Grid>
	);
};
export default UpLoadFiles;
